<template>
  <button class="funnel-card-component rounded-16" @click="editSteps">
    <div class="d-flex justify-content-between align-items-start">
      <div class="content">
        <h5 class="text-semibold">{{ funnel.name }}</h5>
        <h6 class="text-dark-40 fs-12">
          {{ item }}
        </h6>
        <!-- <span class="fs-12 text-neutral-300"> {{ funnel.levels }} estágios </span> -->
      </div>
      <bp-tag :text="status.text" :color="status.color" />
    </div>

    <div class="d-flex justify-content-end" @click.stop>
      <snow-dropdown
        :key="`dropdown-${funnel.id}-${funnel.is_active}`"
        :actions="actions"
        @edit="$emit('edit', funnel)"
        @remove="$emit('remove', funnel.id)"
        @change-status="$emit('changeStatus', funnel)"
      />
    </div>
  </button>
</template>
<script>
export default {
  props: {
    funnel: {
      type: Object,
      required: true
    }
  },
  computed: {
    item() {
      return this.funnel.offer?.name || this.funnel.plan?.name;
    },
    actions() {
      return [
        {
          text: this.funnel.is_active ? "Desativar" : "Ativar",
          class: this.funnel.is_active ? "text-danger" : "text-success",
          confirmation: {
            text: this.funnel.is_active
              ? "Tem certeza que deseja desativar esse funil?"
              : "Tem certeza que deseja ativar esse funil?",
            variant: this.funnel.is_active ? "negative" : "positive",
            icon: "ph ph-prohibit",
            buttonText: this.funnel.is_active
              ? "Sim, desativar"
              : "Sim, ativar",
            secondaryButtonText: "Cancelar"
          },
          event: "change-status"
        },
        {
          text: "Editar Funil",
          event: "edit"
        },
        {
          text: "Excluir",
          class: "text-danger",
          confirmation: {
            text: "Tem certeza que deseja excluir esse funil?",
            variant: "negative",
            icon: "ph ph-trash",
            buttonText: "Sim, excluir",
            secondaryButtonText: "Cancelar"
          },
          event: "remove"
        }
      ];
    },
    status() {
      return {
        text: this.funnel.is_active ? "Ativo" : "Inativo",
        color: this.funnel.is_active ? "green" : "danger"
      };
    }
  },
  methods: {
    editSteps() {
      this.$router.push({
        name: "product-funnel-tree",
        params: { id: this.$route.params.id, tree: this.funnel.tree_id }
      });
    }
  }
};
</script>
<style lang="scss">
.funnel-card-component {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  transition: 0.2s all;
  padding: 24px;

  background-color: var(--bg-1);
  border: 1px solid var(--dark-10);

  &:hover {
    border-color: var(--dark-40);
    box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.12);
  }

  .content {
    gap: 4px;
    display: flex;
    margin-bottom: 12px;
    flex-direction: column;
    align-items: start;
  }
}
</style>
